<template>
  <a-card :bordered="false">
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="formDisabled">
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
          <a-row>
            <a-col :span="24">
              <a-form-model-item label="logo" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="logo">
                <j-image-upload v-model="model.logo"></j-image-upload>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item label="程序名称" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="name">
                <a-input v-model="model.name" placeholder="请输入程序名称"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item label="服务协议" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="agreement">
                <a-textarea v-model="model.agreement" rows="4" placeholder="请输入服务协议"/>
              </a-form-model-item>
            </a-col>
            <!--            <a-col :span="24">-->
            <!--              <a-form-model-item label="pc登录页背景" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="pcLoginBack">-->
            <!--                <j-image-upload  v-model="model.pcLoginBack"></j-image-upload>-->
            <!--              </a-form-model-item>-->
            <!--            </a-col>-->
            <a-col :span="24">
              <a-form-model-item label="小程序轮播背景" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="mpBannerBack">
                <j-image-upload isMultiple v-model="model.mpBannerBack"></j-image-upload>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item label="母牛孕期（月）" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="beefPregnancy">
                <a-input-number v-model="model.beefPregnancy" placeholder="请输入母牛孕期（月）" style="width: 100%"/>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
    <a-button type="primary" @click="submitForm">保存</a-button>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import BeefBasicSettingsModal from './modules/BeefBasicSettingsModal'
  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'BeefBasicSettingsList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      BeefBasicSettingsModal
    },
    data() {
      return {
        description: '基础设置表管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: 'center',
            customRender: function(t, r, index) {
              return parseInt(index) + 1
            }
          },
          {
            title: 'logo',
            align: 'center',
            dataIndex: 'logo',
            scopedSlots: { customRender: 'imgSlot' }
          },
          {
            title: '程序名称',
            align: 'center',
            dataIndex: 'name'
          },
          {
            title: '服务协议',
            align: 'center',
            dataIndex: 'agreement'
          },
          {
            title: 'pc登录页背景',
            align: 'center',
            dataIndex: 'pcLoginBack',
            scopedSlots: { customRender: 'imgSlot' }
          },
          {
            title: '小程序轮播背景',
            align: 'center',
            dataIndex: 'mpBannerBack',
            scopedSlots: { customRender: 'imgSlot' }
          },
          {
            title: '母牛孕期（月）',
            align: 'center',
            dataIndex: 'beefPregnancy'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            fixed: 'right',
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: '/beef/beefBasicSettings/list',
          delete: '/beef/beefBasicSettings/delete',
          deleteBatch: '/beef/beefBasicSettings/deleteBatch',
          exportXlsUrl: '/beef/beefBasicSettings/exportXls',
          add: '/beef/beefBasicSettings/add',
          edit: '/beef/beefBasicSettings/edit',
          queryById: '/beef/beefBasicSettings/queryById',
          importExcelUrl: 'beef/beefBasicSettings/importExcel'

        },
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        confirmLoading: false,
        validatorRules: {}

      }
    },
    created() {
      this.getSuperFieldList()
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model))
      getAction(this.url.list).then(res => {
        this.edit(res.result)
      })
    },
    computed: {
      formDisabled() {
        return this.disabled
      },
      importExcelUrl: function() {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
      }
    },
    methods: {
      edit(record) {
        this.model = Object.assign({}, record)
        this.visible = true
      },
      submitForm() {
        const that = this
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true
            let httpurl = ''
            let method = ''
            if (!this.model.id) {
              httpurl += this.url.add
              method = 'post'
            } else {
              httpurl += this.url.edit
              method = 'put'
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            }).finally(() => {
              that.confirmLoading = false
            })
          }

        })
      },
      initDictConfig() {
      },
      getSuperFieldList() {
        let fieldList = []
        fieldList.push({ type: 'string', value: 'logo', text: 'logo', dictCode: '' })
        fieldList.push({ type: 'string', value: 'name', text: '程序名称', dictCode: '' })
        fieldList.push({ type: 'Text', value: 'agreement', text: '服务协议', dictCode: '' })
        fieldList.push({ type: 'string', value: 'pcLoginBack', text: 'pc登录页背景', dictCode: '' })
        fieldList.push({ type: 'Text', value: 'mpBannerBack', text: '小程序轮播背景', dictCode: '' })
        fieldList.push({ type: 'int', value: 'beefPregnancy', text: '母牛孕期（月）', dictCode: '' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>